import React from 'react'
import Button from '@material-ui/core/Button'
import { useAuth } from 'lib/auth'
import {
  getRegistrationDisabled,
  getRegistrationButtonLabel,
} from './registration-cta-utils'

const RegisterButton = ({
  groupEvent,
  paymentRequired,
  type,
  component,
  to,
}) => {
  const { user } = useAuth()
  const registrationDisabled = getRegistrationDisabled({ user, groupEvent })

  const label = getRegistrationButtonLabel({
    user,
    groupEvent,
    paymentRequired,
  })

  return (
    <Button
      variant="contained"
      color="primary"
      size="large"
      fullWidth
      disabled={registrationDisabled}
      {...{ type, component, to }}
    >
      {label}
    </Button>
  )
}

export default RegisterButton
